import { forEach } from 'lodash';

var createActionInterceptor = function () {
    var _a;return _a = /** @class */function () {
        function actionsInterceptorMiddleware() {}
        actionsInterceptorMiddleware.addActionsCallback = function (actionsHandler) {
            var handlerId = '_' + Math.random().toString(36).substr(2, 9);
            this.actionHandlers[handlerId] = actionsHandler;
            return function () {
                return _a.removeListener(handlerId);
            };
        };
        actionsInterceptorMiddleware.addActionsPromise = function (actionTypes) {
            var _this = this;
            var cleanAction;
            return new Promise(function (resolve) {
                cleanAction = _this.addActionsCallback({
                    actionTypes: actionTypes,
                    callback: resolve
                });
            }).then(function (result) {
                cleanAction();
                return result;
            });
        };
        actionsInterceptorMiddleware.removeListener = function (key) {
            delete _a.actionHandlers[key];
        };
        return actionsInterceptorMiddleware;
    }(), _a.actionHandlers = {}, _a.middleWareFn = function (store) {
        return function (next) {
            return function (action) {
                next(action);
                forEach(_a.actionHandlers, function (actionHandler) {
                    if (actionHandler === null || actionHandler === void 0 ? void 0 : actionHandler.actionTypes.includes(action.type)) {
                        actionHandler.callback({
                            action: action,
                            dispatch: store.dispatch,
                            state: store.getState()
                        });
                    }
                });
                return;
            };
        };
    }, _a;
};

export { createActionInterceptor as c };
